import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button } from '@src/components/Button';
import './styles.scss';

export default function Header({ title, children, buttonLabel, buttonDisabled, onButtonClick }) {
  return (
    <div className={classnames('ewc-header', { 'ewc-header--has-children': children })}>
      <div className="ewc-header__container">
        {title && (
          <div className="ewc-header__title">
            <h3>{title}</h3>
          </div>
        )}

        {buttonLabel && (
          <Button className="ewc-header__button" isDisabled={buttonDisabled} onClick={onButtonClick}>
            {buttonLabel}
          </Button>
        )}
      </div>

      {children}
    </div>
  );
}

Header.propTypes = {
  buttonDisabled: PropTypes.bool,
  buttonLabel: PropTypes.string,
  children: PropTypes.node,
  onButtonClick: PropTypes.func,
  title: PropTypes.string,
};
